/*
 * File: input.data.ts
 * File Created: 2024-01-13 02:54:13
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-13 07:15:51
 * Modified By: Val Liu
 * -----
 */

// import { Property } from "@/views/AdminPages/Property/quick";
// import { PropertyEquipmentPartsInventory } from "@/views/AdminPages/PropertyEquipmentPartsInventory/quick";
// import { PropertyGroup } from "@/views/AdminPages/PropertyGroup/quick";
// import { PropertyRentalUnit } from "@/views/AdminPages/PropertyRentalUnit/quick";

const selection = {
    選項一: 0,
    選項二: 1,
    選項三: 2,
};

export const inputData = [
    createDefaultData("Month", "iv-input-month", false, { value: new Date() }),

    createDefaultData("Cron", "iv-input-cron", false, {
        value: "* * * * * ? *",
    }),

    // /// iv-input-tree-select
    // createDefaultData("Tree Select", "iv-input-tree-select", false, {
    //     quicks: [
    //         Profile_PropertyGroup,
    //         Profile_Property,
    //         Profile_PropertyEquipmentPartsInventory,
    //     ],
    //     value: { id: "ade01927-011e-4cff-a153-5d8e4453bfd4" },
    // }),

    /// iv-input-file-classic
    createDefaultData("File Classic", "iv-input-file-classic", false),
    // /// iv-input-file
    // {
    //     type: "File",
    //     normal: {
    //         is: "iv-input-file",
    //         value: [
    //             {
    //                 id: "5f8b0815-b030-429c-9ef9-43d20c277ec7",
    //                 originalName: "test.jpg",
    //                 size: 1024,
    //                 contentType: "image/jpeg",
    //             },
    //         ],
    //     },
    // },
    createDefaultData("File", "iv-input-file", false, {
        value: undefined,
        // value: {
        //     id: "09d1244b-8e92-4184-984f-47baaca299e7",
        //     createdAt: "2024-02-17T07:56:56.999Z",
        //     updatedAt: "2024-02-17T07:56:56.999Z",
        //     name: "file-1708156616996-87165409.jpg",
        //     originalName: "LINE_ALBUM_20211111戶外教學-台北市立動物園_211112_0.jpg",
        //     size: 345295,
        //     path: "D:\\Files\\temp\\20240217\\095\\file-1708156616996-87165409.jpg",
        //     contentType: "image/jpeg",
        //     title: "瀞元",
        // },
    }),
    /// iv-input-file (multiple)
    createDefaultData("File (Multiple)", "iv-input-file", false, {
        multiple: true,
        value: undefined,
        // value: [
        //     {
        //         id: "09d1244b-8e92-4184-984f-47baaca299e7",
        //         createdAt: "2024-02-17T07:56:56.999Z",
        //         updatedAt: "2024-02-17T07:56:56.999Z",
        //         name: "file-1708156616996-87165409.jpg",
        //         originalName: "LINE_ALBUM_20211111戶外教學-台北市立動物園_211112_0.jpg",
        //         size: 345295,
        //         path: "D:\\Files\\temp\\20240217\\095\\file-1708156616996-87165409.jpg",
        //         contentType: "image/jpeg",
        //         title: "瀞元",
        //     },
        // ],
    }),
    /// iv-input-date
    createDefaultData("Date", "iv-input-date", false, { value: new Date() }),
    /// iv-input-date
    createDefaultData("Date (Multi)", "iv-input-date", false, {
        multiple: true,
        value: [new Date("2024/1/15"), new Date("2024/1/17")],
    }),
    /// iv-input-date
    createDefaultData("Date (Range)", "iv-input-date", false, {
        multiple: "range",
        value: [new Date("2024/1/15"), new Date("2024/1/17")],
    }),
    /// iv-input-time
    createDefaultData("Time", "iv-input-time", false, { value: new Date() }),
    // /// iv-input-time
    // createDefaultData("Time (Multi)", "iv-input-time", false, {
    //     multiple: true,
    //     value: [new Date("2024/1/15 15:00"), new Date("2024/1/17 17:00")],
    // }),
    // /// iv-input-time
    // createDefaultData("Time (Range)", "iv-input-time", false, {
    //     multiple: "range",
    //     value: [new Date("2024/1/15 15:00"), new Date("2024/1/17 17:00")],
    // }),
    /// iv-input-datetime
    createDefaultData("DateTime", "iv-input-datetime", false, { value: new Date() }),
    /// iv-input-datetime
    createDefaultData("DateTime (Multi)", "iv-input-datetime", false, {
        multiple: true,
        value: [new Date("2024/1/15 15:00"), new Date("2024/1/17 17:00")],
    }),
    /// iv-input-datetime
    createDefaultData("DateTime (Range)", "iv-input-datetime", false, {
        multiple: "range",
        value: [new Date("2024/1/15 15:00"), new Date("2024/1/17 17:00")],
    }),
    /// iv-input
    createDefaultData("Text", "iv-input-string", false, { value: "Text" }),
    /// iv-input-number
    createDefaultData("Number", "iv-input-number", false, { value: 12800000 }),
    /// iv-input-password
    createDefaultData("Password", "iv-input-password", false, { value: "123456" }),
    /// iv-input-email
    createDefaultData("Email", "iv-input-email", false, {
        value: "valuis0429@gmail.com",
    }),
    /// iv-input-ip
    createDefaultData("IP", "iv-input-ip", false, { value: "192.168.100.100" }),
    /// iv-input-textarea
    createDefaultData("Textarea", "iv-input-textarea", false, { value: "TextArea" }),
    /// iv-input-check
    createDefaultData("Radio", "iv-input-check", false, {
        options: selection,
        value: selection.選項一,
        multiple: false,
    }),
    /// iv-input-check
    createDefaultData("Checkbox", "iv-input-check", false, {
        options: selection,
        value: [selection.選項一, selection.選項二],
        multiple: true,
    }),
    /// iv-input-select
    createDefaultData("Select", "iv-input-select", null, {
        options: selection,
        clearable: true,
        value: selection.選項一,
    }),
    /// iv-input-select (multiple)
    createDefaultData("Select (Multi)", "iv-input-select", null, {
        options: selection,
        clearable: true,
        multiple: true,
        value: [selection.選項一, selection.選項二],
    }),
    /// iv-input-switch
    {
        type: "Switch",
        normal: [
            {
                is: "iv-input-switch",
            },
            {
                is: "iv-input-switch",
                value: true,
            },
            {
                is: "iv-input-switch",
                value: false,
            },
        ],
        stateTrue: [
            {
                is: "iv-input-switch",
                state: true,
            },
            {
                is: "iv-input-switch",
                value: true,
                state: true,
            },
            {
                is: "iv-input-switch",
                value: false,
                state: true,
            },
        ],
        stateFalse: [
            {
                is: "iv-input-switch",
                state: false,
            },
            {
                is: "iv-input-switch",
                value: true,
                state: false,
            },
            {
                is: "iv-input-switch",
                value: false,
                state: false,
            },
        ],
        disabled: [
            {
                is: "iv-input-switch",
                disabled: true,
            },
            {
                is: "iv-input-switch",
                value: true,
                disabled: true,
            },
            {
                is: "iv-input-switch",
                value: false,
                disabled: true,
            },
        ],
        sizing: [
            {
                is: "iv-input-switch",
                size: "sm",
                value: true,
            },
            {
                is: "iv-input-switch",
                size: "md",
                value: true,
            },
            {
                is: "iv-input-switch",
                size: "lg",
                value: true,
            },
            {
                is: "iv-input-switch",
                size: "xl",
                value: true,
            },
        ],
    },
];

function createDefaultData(type: string, is: string, xl?: boolean | null, args?: any) {
    return {
        type,
        normal: { is, ...args },
        stateTrue: { is, state: true, ...args },
        stateFalse: { is, state: false, ...args },
        disabled: { is, disabled: true, ...args },
        ...(xl == null
            ? {}
            : {
                  sizing: [
                      { is, size: "sm", ...args },
                      { is, size: "md", ...args },
                      { is, size: "lg", ...args },
                      ...(xl ? [{ is, size: "xl", ...args }] : []),
                  ],
              }),
    };
}
